import apiHandler from "../core/apiHandler";

const cashCountApi = apiHandler("cash/counts");

export default cashCountApi;